import React from "react";
import ReactQuill from "react-quill/lib";
import "react-quill/dist/quill.snow.css";
import { Typography, FormHelperText, FormControl, styled } from "@mui/material";

const ReactQuillStyled = styled(ReactQuill)(({ theme, styles }) => ({
  "& .ql-container.ql-snow": {
    border: styles.border
  },
  "& .ql-editor": {
    height: styles.height ?? 200,
  },
}));

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
];

const isQuillEmpty = (value) => {
  if (
    value.replace(/<(.|\n)*?>/g, "").trim().length === 0 &&
    !value.includes("<img")
  ) {
    return true;
  }
  return false;
};

function Quill({
  title,
  value,
  sx,
  helperText,
  readOnly,
  onChange,
  toolbar = modules.toolbar,
  styles = {}
}) {
  return (
    <FormControl fullWidth sx={sx}>
      <Typography>{title}</Typography>
      <ReactQuillStyled
        modules={{
          toolbar,
        }}
        styles={styles}
        formats={formats}
        defaultValue={value}
        onChange={(value) => onChange?.(!isQuillEmpty(value) ? value : "")}
        readOnly={readOnly}
      />
      {helperText && <FormHelperText error>{helperText}</FormHelperText>}
    </FormControl>
  );
}

export default Quill;
